import { FIELD_PATHS } from '@funnels/constants';
import { IncomeEntityIndex } from '@funnels/types';

import { DollarInputField } from '../../Fields';

const QUARTERS = ['1 (Jul - Sep)', '2 (Oct - Dec)', '3 (Jan - Mar)', '4 (Apr - Jun)'];

interface BusinessBASProps extends IncomeEntityIndex {
  quarter: number;
  hasLabel?: boolean;
  isOptional?: boolean;
  isDisabled?: boolean;
  disableFailMessage?: boolean;
}

export const BusinessBAS = (props: BusinessBASProps) => {
  const { quarter, hasLabel = false, incomeIndex, ...rest } = props;

  return (
    <DollarInputField
      {...rest}
      name={FIELD_PATHS.INCOME_BUSINESS_BAS_SALES_AMOUNT(incomeIndex, quarter)}
      label={hasLabel ? `BAS Sales in quarter ${QUARTERS[quarter]}` : undefined}
      isZeroValid
    />
  );
};
